import React from 'react';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { FormattedMessage } from 'react-intl';
import { EnabledDisabled } from 'modules/Settings/constant';
import { EnabledDisabledDropdown } from './EnabledDisabledDropdown';
import { OptedInDropdown } from './OptedInDropdown';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    borderRadius: theme.spacing(0, 1.25, 0, 0),
    alignContent: 'flex-start',
    marginTop: theme.spacing(1)
  },
  dropDown: {
    marginRight: theme.spacing(1)
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  button: {
    marginLeft: theme.spacing(2),
    textTransform: 'none'
  },
  buttonText: {
    fontWeight: theme.typography.fontWeightMedium
  }
}));
type DefaultSettingsRowProps = {
  disabled?: boolean;
  defaultEnabled: EnabledDisabled;
  defaultOptedIn: EnabledDisabled;
  handleClick: () => void;
};

export const DefaultSettingsRow: React.FC<DefaultSettingsRowProps> = ({
  disabled = true,
  defaultEnabled,
  defaultOptedIn,
  handleClick
}: DefaultSettingsRowProps) => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <div className={classes.dropDown}>
        <EnabledDisabledDropdown value={defaultEnabled} rowID={'defaultRow'} />
        <OptedInDropdown value={defaultOptedIn} rowID={'defaultRow'} />
      </div>
      <Typography display="inline" className={classes.text} variant="body2">
        <FormattedMessage id="settings.defaultValue" />
      </Typography>
      <Button
        className={classes.button}
        size="small"
        color="primary"
        onClick={handleClick}
        data-testid={'add-target-button'}
        disabled={disabled}
      >
        <AddOutlinedIcon fontSize="inherit" />
        <Typography
          display="inline"
          className={classes.buttonText}
          variant="body2"
        >
          <FormattedMessage id="settings.addTargetButton" />
        </Typography>
      </Button>
    </div>
  );
};
